import { apiClient, handleResponse } from './axios';

async function getAll() {
  try {
    const response = await apiClient.get('/resources');
    const ressources = await handleResponse(response);
    return ressources;
  } catch (error) {
    return error.response;
  }
}

async function addNewResource(body) {
  try {
    const response = await apiClient.post('/resources', body);
    const resources = await handleResponse(response);
    return resources;
  } catch (error) {
    return error.response;
  }
}

async function deleteResource(id) {
  try {
    const response = await apiClient.delete(`/resources/${id}`);
    const ressources = await handleResponse(response);
    return ressources;
  } catch (error) {
    return error.response;
  }
}

async function updateResource(id, body) {
  try {
    const response = await apiClient.put(`/resources/${id}`, body);
    const ressources = await handleResponse(response);
    return ressources;
  } catch (error) {
    return error.response;
  }
}

async function getLanguage() {
  try {
    const response = await apiClient.get('/language/');
    const ressources = await handleResponse(response);
    return ressources;
  } catch (error) {
    return error.response;
  }
}

async function getCategorie() {
  try {
    const response = await apiClient.get('/category/');
    const ressources = await handleResponse(response);
    return ressources;
  } catch (error) {
    return error.response;
  }
}

async function addCategorie(body) {
  try {
    const response = await apiClient.post('/category/', body);
    const ressources = await handleResponse(response);
    return ressources;
  } catch (error) {
    return error.response;
  }
}

async function deleteCategorie(catId) {
  try {
    const response = await apiClient.delete(`/category/${catId}`);
    const ressources = await handleResponse(response);
    return ressources;
  } catch (error) {
    return error.response;
  }
}

const resourceServices = {
  getAll,
  addNewResource,
  deleteResource,
  updateResource,
  getLanguage,
  getCategorie,
  addCategorie,
  deleteCategorie,
};

export default resourceServices;
